import { GetBodyAdjusterImageTabsAlertsQueryParamType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyAdjusterImageTabsAlerts/getBodyAdjusterImageTabsAlertsQuery.type';
import { getBodyAdjusterImageTabsAlertsQueryFunctions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyAdjusterImageTabsAlerts/getBodyAdjusterImageTabsAlertsQueryFunctions';
import { queryOptions } from '@tanstack/react-query';

const getBodyAdjusterImageTabsAlertsQueryOptions = (
  params: GetBodyAdjusterImageTabsAlertsQueryParamType,
) =>
  queryOptions({
    queryKey: ['GET_BODY_IMAGE_TABS_ALERTS', params],
    queryFn: () => getBodyAdjusterImageTabsAlertsQueryFunctions(params),
  });
export default getBodyAdjusterImageTabsAlertsQueryOptions;
